import { render, staticRenderFns } from "./TenantPostFitOutComment.vue?vue&type=template&id=2b477c06&scoped=true&"
import script from "./TenantPostFitOutComment.vue?vue&type=script&lang=js&"
export * from "./TenantPostFitOutComment.vue?vue&type=script&lang=js&"
import style0 from "./TenantPostFitOutComment.vue?vue&type=style&index=0&id=2b477c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b477c06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b477c06')) {
      api.createRecord('2b477c06', component.options)
    } else {
      api.reload('2b477c06', component.options)
    }
    module.hot.accept("./TenantPostFitOutComment.vue?vue&type=template&id=2b477c06&scoped=true&", function () {
      api.rerender('2b477c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/TenantPostFitOutComment.vue"
export default component.exports